import {
  THERAPY_DISCIPLINE_NUTRITION_CONSULTATION,
  resolveTherapyDiscipline,
} from 'src/consumer/constants'

/**
 * Discipline-aware display labels for the therapy-report editor.
 *
 * The same backend report type (`therapy-report`) is rendered as either
 * "Therapy Report" (psychotherapy, the default) or "Nutrition Consultation Report"
 * (nutrition discipline). The discipline lives on the booked event / saved report and is
 * resolved with `resolveTherapyDiscipline` from `src/consumer/constants`.
 *
 * Use these helpers anywhere a user-visible label, page title, save toast, tab name, or
 * download filename references the report. Practitioner-wide settings (e.g. EMR-section tab
 * labels) intentionally stay "Therapy Report" — they apply to both disciplines.
 */

/** Long form, used for headings, dialogs, toasts. */
export function getTherapyReportLabel(discipline) {
  if (discipline === THERAPY_DISCIPLINE_NUTRITION_CONSULTATION) {
    return 'Nutrition Consultation Report'
  }
  return 'Therapy Report'
}

/** Short form, used in compact UI (tabs, breadcrumbs). */
export function getTherapyReportShortLabel(discipline) {
  if (discipline === THERAPY_DISCIPLINE_NUTRITION_CONSULTATION) {
    return 'Nutrition Consultation'
  }
  return 'Therapy Report'
}

/** Filesystem-safe slug — used in PDF / SEO filenames. */
export function getTherapyReportSlug(discipline) {
  if (discipline === THERAPY_DISCIPLINE_NUTRITION_CONSULTATION) {
    return 'Nutrition_consultation_report'
  }
  return 'Therapy_report'
}

/** Convenience: resolve discipline from an entity then label. Accepts booked event OR report. */
export function getTherapyReportLabelFromEntity(bookedEventOrReport) {
  return getTherapyReportLabel(resolveTherapyDiscipline(bookedEventOrReport))
}

export function getTherapyReportShortLabelFromEntity(bookedEventOrReport) {
  return getTherapyReportShortLabel(resolveTherapyDiscipline(bookedEventOrReport))
}
